<template>

<!--  <el-drawer-->
<!--      :visible.sync="drawer"-->
<!--      :direction="direction"-->
<!--      title="手绘签名"-->
<!--      size="calc((705 / 932) * 100vh)"-->
<!--      :before-close="handleClose">-->

  <div class="page">
    <div class="dialog-header">
      <div class="fc3 fw">手写签名采集</div>
    </div>

    <div class="dialog-body">

      <div class="dialog-content">
        <div class="top-area mb15">
          <div class="name-area flex-center">
            <div class="name-item" v-for="(item,index) in name" :key="index"
                 :class="currentIndex==index?'name-item-active':'name-item-inactive'"
                 @click="onClick(item,index)">
              <div v-if="!item.url">
                {{item.word}}
              </div>
              <!--                <image v-if="item.url" @click.stop="clearUrl(index)" class="icon-clear"-->
              <!--                       src="../../../static/images/icon-clear.png" mode=""></image>-->
              <i v-if="item.url" class="el-icon-error icon-clear" @click.stop="clearUrl(index)"></i>
              <!--                <image v-if="item.url" class="image-word" :src="item.url" alt="Base64 Image"></image>-->
              <el-image
                  v-if="item.url"
                  class="image-word"
                  :src="item.url"
                  fit="fit"></el-image>
            </div>
          </div>
          <div class="tac mt15" v-show="!this.allUrl">
            请在下方区域书写第{{name[currentIndex].order||''}}个字“{{name[currentIndex].word||''}}”
          </div>
          <div class="tac mt15" v-show="this.allUrl">
            签名完成，点击确定
          </div>
        </div>

        <div class="write-area" >
          <!--            <lsignature style="height: 700rpx;z-index: 10;" disableScroll ref="signatureRef"-->
          <!--                         :penColor="currentColor" :penSize="penSize" :openSmooth="openSmooth">-->
          <!--            </lsignature>-->


          <VueSignaturePad
              id="signature"
              class="signature-pad"
              width="100%"
              height="calc((384 / 932) * 100vh)"
              ref="signaturePad"
              :options="options"
          />

          <div class="sign-bg flex-center" v-for="(item,index) in name" :key="index" v-if="currentIndex == index">
            <div class="bg-line1">
            </div>
            <div class="bg-line2">
            </div>
            {{name[currentIndex].word}}
          </div>

          <!-- <image class="image-bg" src="../../../static/images/word-bg-white.png" mode=""></image> -->
        </div>
        <div class="tac fz17 mt15" style="color: #000000">
          通过AI智能识别手写文字，保障签署更准确
        </div>
      </div>

      <div class="dialog-footer">
        <div class="block-area flex-c">
          <div class="block block-black mr25 flex-center" @click="handleColor('black' , 0)">
            <i  v-if="options.penColor=='black'" class="el-icon-check" />
          </div>
          <div class="block block-red mr25 flex-center" @click="handleColor('red' , 1)">
            <i v-if="options.penColor=='red'" class="el-icon-check" />
          </div>
          <div class="block block-blue flex-center" @click="handleColor('blue' , 2)">
            <i v-if="options.penColor=='blue'" class="el-icon-check" />
          </div>
        </div>
        <el-button class="dialog-footer-btn" type="danger" @click="onConfirm()">确定</el-button>
<!--        <div class="dialog-footer-btn confirm" @click="getImage()">确定</div>-->
      </div>

    </div>
  </div>



<!--  </el-drawer>-->

</template>

<script>


export default {
  // props: {
  //   drawer: {
  //     type: Boolean,
  //     default: () => {
  //       return false
  //     }
  //   },
  //   signInfo: {
  //     type: Object,
  //     default: () => {
  //       return {}
  //     }
  //   }
  // },
  data() {
    return {
      direction: 'btt',
      currentIndex: 0,
      name: [{
        order: undefined,
        word: undefined
      }],
      openSmooth: true,
      penSize: 5,
      currentColor: 'black',
      allUrl: false,

      url: '',
      // 手写板参数
      options: {
        penColor: "black", //控制画笔颜色
        minWidth: 5,    //控制画笔最小宽度
        maxWidth: 5,    //控制画笔最大宽度
        colorNumber: 0, //给后台传参 黑0 红1 蓝2
      },

      // 从地址获取的token
      queryParams:{
        token: null
      },
    };
  },
  created() {
    // 获取token
    this.queryParams.token = this.$route.query.t;

    this.getData(this.queryParams)

  },

  mounted() {
  },
  methods: {
    // 调取接口提交合成的图片
    submit(){
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let tempUrl = this.url.replace('data:image/png;base64,', '')
      let  params = {
        image: tempUrl ,
        token: this.queryParams.token ,
        color: this.options.colorNumber
      }
      this.$http.post(this.$api.handWriting.verifySignature, params).then((res) => {
        if (res.data.code == 200) {
          this.$message.success('采集成功');

          setTimeout(() => {
            loading.close();
            // 延时跳转
            if(this.signInfo.pageToUrl){
              this.$router.push(this.signInfo.pageToUrl);
            }else {
              if (window.WeixinJSBridge) {
                window.WeixinJSBridge.call('closeWindow') // 微信，只是微信就用这个API。
              } else if (window.AlipayJSBridge) {
                window.AlipayJSBridge.call('closeWebview') // 支付宝
              } else {
                this.$router.back()
              }
            }
          }, 1000)
        }else {
          loading.close();
          this.$message.error(res.data.msg);
        }


      })
    },

    // 通过token获取签名人姓名
    getData(queryParams){
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.$http.post(this.$api.handWriting.getInfo, queryParams).then((res) => {
        if (res.data.code == 200) {
          this.signInfo = res.data.data
          this.resetData(res.data.data)
          loading.close();
        }else {
          this.$message.error(res.data.msg);

          setTimeout(() => {
            loading.close();
            // 延时跳转
            if (window.WeixinJSBridge) {
              window.WeixinJSBridge.call('closeWindow') // 微信，只是微信就用这个API。
            } else if (window.AlipayJSBridge) {
              window.AlipayJSBridge.call('closeWebview') // 支付宝
            } else {
              this.$router.back()
            }
          }, 1000)
        }
      }).catch((err) => {
        this.$message.error(err.message);
        setTimeout(() => {
          // 延时跳转
          if (window.WeixinJSBridge) {
            window.WeixinJSBridge.call('closeWindow') // 微信，只是微信就用这个API。
          } else if (window.AlipayJSBridge) {
            window.AlipayJSBridge.call('closeWebview') // 支付宝
          } else {
            this.$router.back()
          }
        }, 1000)
      })
    },

    // 删除
    clearUrl(index) {
      let temp = this.name[index]
      temp.url = undefined
      this.$set(this.name, index, temp)
    },

    // 生成base64的 图片格式
    onClick(item,index){
      let { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      // if (isEmpty) {
        // this.$message('请签名后再生成签字图片');
      //   return
      // }
      if (!this.name[this.currentIndex].url){
        this.name[this.currentIndex].url = data
      }
      this.$refs.signaturePad.clearSignature()
      this.currentIndex = index

    },

    // 确定
    onConfirm(){
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      this.onClick({}, this.currentIndex)

      let allUrl = this.name.every(item =>item.url)

      if (!allUrl){
        this.$message('请将姓名填写完整')
        loading.close();
        return
      }

      this.combineBase64Images(this.name);

      loading.close();

    },

    // 将多个base64图片合成一个
    combineBase64Images(images , callback) {
      // 创建一个canvas元素
      let canvas = document.createElement('canvas');
      let ctx = canvas.getContext('2d');
      //
      let imgWidth = 500; // 假设所有图片将合并成这个宽度
      let imgHeight = 1200; // 假设所有图片将合并成这个高度
      let tempWidth = (images.length * imgWidth) + (500 * images.length) + 325
      canvas.width = tempWidth;
      canvas.height = imgHeight;

      let imagesLoaded = 0;
      let len = images.length;
      for (let i = 0; i < len; i++) {
        let offsetWidth = 1080 * i
        let img = new Image();
        img.src = images[i].url;
        img.onload = () => {
          // 绘制图片到canvas
          ctx.drawImage(img, offsetWidth, 0);
          imagesLoaded++;
          // 检查是否所有图片都已加载
          if (imagesLoaded === len) {
            // callback(canvas.toDataURL('image/png')); // 使用PNG格式输出合成后的图片
            this.url = canvas.toDataURL('image/png')
            this.submit()
          }
        };
      }
    },

    // 通过签名人信息生成对应数组
     resetData(info) {
      let arr = ['一', '二', '三', '四', '五', '六', '七', '八', '九']
      if (info) {
        if (info.userName) {
          let temp = info.userName.split('')
          temp = temp.map((item, index) => {
            return {
              word: item,
              url: undefined,
              order: arr[index]
            }
          })
          this.name = temp
        }
      }
    },
    handleColor(color, number) {
      this.options.penColor = color
      this.options.colorNumber = number
      this.$set(this.options, this.options);
    },
    handleClose() {
      this.$confirm('确认关闭？')
          .then(()=> {
            this.updateDrawer(false)
          })
          .catch(() => {});
    },

    // async onClick(type, item, index) {
    //   if (type == 'save') {
    //     await new Promise((resolve, reject) => {
    //       this.$refs['signatureRef'][0].canvasToTempFilePath({
    //         success: (res) => {
    //           // 是否为空画板 无签名
    //           // console.log(res.isEmpty)
    //           // 生成图片的临时路径, H5 生成的是base64
    //           if (res.isEmpty) {
    //             this.currentIndex = index
    //             resolve(res);
    //             return
    //           }
    //           let temp = this.name[this.currentIndex]
    //           temp.url = res.tempFilePath
    //           this.submitImage(temp, this.currentIndex).then(result => {
    //             if (this.name[this.currentIndex].isOk == 'yes') {
    //               this.$set(this.name, this.currentIndex, temp)
    //               this.$nextTick(() => {
    //                 this.allUrl = this.name.every(item =>
    //                     item.url)
    //                 this.currentIndex = index
    //               })
    //             } else {
    //               // this.$refs['signatureRef'][0].clear()
    //               this.$refs.signaturePad.clearSignature()
    //             }
    //             resolve(res);
    //           })
    //         }
    //       })
    //     })
    //     return
    //   }
    //   if (this.$refs.signatureRef)
    //     this.$refs.signatureRef[type]()
    // },

    /* 更新visible */
    updateDrawer(value) {
      this.$emit('update:drawer', value);
    }
  }
};
</script>

<style scoped lang="less">
.page{
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.dialog-header {
  position: fixed;
  top: 0 ;
  margin: 0 30px;
  height: 64px;
  line-height: 100px;
  margin-bottom: 30px;
  position: relative;
  text-align: center;
  font-size: 24px;
}
.dialog-body {
  width: 100%;
  background-color: #fff;
  margin-bottom: calc((250 / 932) * 100vh);
  // border-radius: 20rpx 20rpx 0 0;
  .dialog-content {
    padding: 0 calc((11 / 430) * 100vw);
    // max-height: 50vh;
    overflow-y: scroll;

    .name-area {
      height: calc((76 / 932) * 100vh);
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .name-item {
      position: relative;
      width: calc((54 / 932) * 100vh);
      height: calc((54 / 932) * 100vh);
      margin-right: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 3px;
      font-size: 40px;
      font-family: 'Regular';

      .image-word {
        position: absolute;
        height: calc((54 / 932) * 100vh);
        width: calc((54 / 430) * 100vw);
      }

      .icon-clear {
        position: absolute;
        font-size: calc((19 / 430) * 100vw);
        top: -10px;
        right: -10px;
      }
    }

    .name-item-active {
      color: #1890ff;
      border: 1px solid #1890ff;
      box-shadow: 0px 0px 1px 0px #1890ff
    }

    .name-item-inactive {
      color: #000;
      border: 1px solid #99999961;
    }

    .signature-pad{
      position: relative;
      z-index: 10;
      background-color: rgba(0,0,0,0.1);
    }

    .write-area {
      position: relative;
      width: 100%;
      height: calc((384 / 932) * 100vh);


      .image-bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: calc((384 / 932) * 100vh);
        z-index: 9;
      }

      .sign-bg {
        background: #F4F6F8;
        position: relative;
        top: calc((384 / 932) * -100vh);
        left: 0;
        width: 100%;
        height: calc((384 / 932) * 100vh);
        z-index: 9;
        font-size: calc((307 / 932) * 100vh);
        text-align: center;
        font-family: 'Regular';
        color: #E6EBEE;

        display: flex;
        justify-content: center;
        align-items: center;

        .bg-line1 {
          position: absolute;
          top: 50%;
          width: 100%;
          height: 1px;
          border-bottom: 2px dashed #EAECED;
        }

        .bg-line2 {
          position: absolute;
          top: 50%;
          transform: rotate(90deg);
          width: calc((384 / 932) * 100vh);
          height: 1px;
          border-bottom: 2px dashed #EAECED;
        }
      }
    }
  }

  .dialog-footer {
    position: fixed;
    bottom: calc((20 / 932) * 100vh) ;

    width: 100%;
    padding: calc((10 / 932) * 100vh) calc((16 / 430) * 100vw);
    display: flex;
    justify-content: space-between;
    align-items: center;

    .dialog-footer-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: calc((197 / 430) * 100vw);
      height: calc((43 / 932) * 100vh);
      background: #f38383;
      color: #fff;
    }

    .dialog-footer-btn+.dialog-footer-btn {
      margin-left: 15px;
    }

    .block-area {
      display: flex;
      padding: 0 calc((27 / 430) * 100vw);
      box-sizing: border-box;
    }

    .block {
      width: calc((30 / 430) * 100vw);
      height: calc((30 / 430) * 100vw);
      border-radius: 50%;
      color: #ffffff;
      font-size: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .block-red {
      background: red;
    }

    .block-black {
      background: #000;
    }

    .block-blue {
      background: blue;
    }

    .icon-color {
      width: calc((21 / 430) * 100vw);
      height: calc((21 / 430) * 100vw);
    }
  }
}

uni-canvas>canvas {
  width: calc((410 / 430) * 100vw) !important;
  height: calc((384 / 932) * 100vh) !important;
}
</style>
